import React from 'react';
import { reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../../text/messages';
import WizardButtons from '../../../../../../../components/wizard/navigator/buttons';

class ReclassificationForm extends React.Component {
    icOnlyText() {
        const { handleSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12">
                        <p>
                            <FormattedMessage
                                id={'yourClassification.intro1'}
                                defaultMessage="You don't qualify for Independent Contractor status"
                                tagName={'strong'}
                            />
                        </p>
                        <p>
                            In the United States, certain work situations are only legally compliant if the worker is a W-2 employee. From what you've told us,
                            your situation is one of these.
                        </p>
                        <p>
                            Even if you may have a company or consulting entity set up, and even if you may have worked as a 1099 independent contractor before,
                            current government regulations and the policies of this client require that we hire you as a temporary employee of GreenLight for
                            the duration of the assignment.
                        </p>
                        <p>
                            After you press OK below, you'll go back one page where you'll be asked to submit a brief explanation. Or, if you think you may have
                            answered any questions incorrectly, you can select 'As a Business' and correct them.
                        </p>
                    </div>
                </div>
                <WizardButtons disabled={submitting} submit={{ message: <FormattedMessage {...messages.ok} /> }} />
            </form>
        );
    }

    w2Text() {
        const { handleSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12">
                        <p>
                            <FormattedMessage
                                id={'yourClassification.intro1'}
                                defaultMessage={'We need to hire you as a temporary employee of GreenLight.'}
                                tagName={'strong'}
                            />
                        </p>
                        <p>
                            In the United States, certain work situations are only legally compliant if the worker is a W-2 employee. From what you've told us,
                            your situation is one of these.
                        </p>
                        <p>
                            Even if you may have a company or consulting entity set up, and even if you may have worked as a 1099 independent contractor before,
                            current government regulations and the policies of this client require that we hire you as a temporary employee of GreenLight for
                            the duration of the assignment.
                        </p>
                        <p>
                            It's not all bad! As our W-2 employee, you don't have to chase invoices - we'll pay you every week on behalf of the client. You
                            won't owe US self-employment taxes on income from this assignment, since those are covered for you. And, if the assignment lasts
                            long enough, you'll be eligible for GreenLight employee benefits, also subsidized by the client.
                        </p>
                        <p>After you press OK below, you'll go back one page where you can review what this means in more detail.</p>
                    </div>
                </div>
                <WizardButtons disabled={submitting} submit={{ message: <FormattedMessage {...messages.ok} /> }} />
            </form>
        );
    }

    render() {
        const { icOnly } = this.props;

        return icOnly ? this.icOnlyText() : this.w2Text();
    }
}
export default reduxForm({ form: 'contractor-onboarding-wizard-return-to-choice' })(ReclassificationForm);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/assets/reclassificationForm.jsx